import React, { useEffect } from 'react';
import Scene from './components/Scene';
import HUDPanel from './components/HUDPanel';
import Filters from './components/Filters';
import LoadingScreen from './components/LoadingScreen';
import ErrorScreen from './components/ErrorScreen';
import StatsBar from './components/StatsBar';
import useStore from './store';
import { loadGraphData } from './graphLoader';

function App() {
  const { loading, error, graphData, setGraphData, setError } = useStore();
  
  useEffect(() => {
    loadGraphData()
      .then(data => {
        console.log('✓ Graph data loaded:', data.nodes.length, 'nodes');
        setGraphData(data);
      })
      .catch(err => {
        console.error('✗ Failed to load graph:', err);
        setError(err.message);
      });
  }, [setGraphData, setError]);
  
  if (loading) {
    return <LoadingScreen />;
  }
  
  if (error) {
    return <ErrorScreen error={error} />;
  }
  
  return (
    <div className="dustytrain-app">
      <Scene />
      <StatsBar />
      <HUDPanel />
      <Filters />
      
      <div className="hud-branding">
        <h1>DUSTYTRAIN.IO</h1>
        <p>OPEN INFRASTRUCTURE INTELLIGENCE ENGINE</p>
      </div>
      
      <div className="hud-legend">
        <h3>ACTIVE PUBLIC WORKS BIDS</h3>
        <div className="legend-items">
          <div className="legend-item">
            <span className="legend-dot water"></span>
            <span>Water & Utilities</span>
          </div>
          <div className="legend-item">
            <span className="legend-dot environmental"></span>
            <span>Environmental</span>
          </div>
          <div className="legend-item">
            <span className="legend-dot transportation"></span>
            <span>Transportation</span>
          </div>
          <div className="legend-item">
            <span className="legend-dot construction"></span>
            <span>Construction</span>
          </div>
        </div>
      </div>
      
      {/* Show message when no data loaded yet */}
      {graphData && graphData.nodes.length === 0 && (
        <div style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          textAlign: 'center',
          color: '#05f3ff',
          zIndex: 1000
        }}>
          <h2 style={{ fontSize: '2rem', marginBottom: '1rem' }}>
            AWAITING DATA CONNECTION
          </h2>
          <p style={{ color: 'rgba(255,255,255,0.6)' }}>
            Connect your D1 database to see live bids
          </p>
        </div>
      )}
      
      <div className="hud-label top-left">SUPPLIER<br/>NETWORKS</div>
      <div className="hud-label top-right">LEGISLATIVE<br/>NETWORKS</div>
      <div className="hud-label bottom-right">LEGISLATIVE<br/>IMPACT</div>
    </div>
  );
}

export default App;